import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    connect() {
        // Opens the panel matching the checked radio button
        this.radioTargets.forEach((r) => {
            if (r.checked) {
                const panelId = r.dataset.toggleTarget;
                if (panelId) {
                    const panel = document.getElementById(panelId);
                    if (panel)
                        panel.classList.remove("d-none");
                }
            }
        });
    }
    toggle(panel, isChecked) {
        // Hide all panels first
        this.panelsTargets.forEach((p) => {
            p.classList.add("d-none");
            this.clearFields(p);
        });
        if (panel) {
            // Radio buttons
            panel.classList.toggle("d-none", !isChecked);
            if (!isChecked)
                this.clearFields(panel);
        }
        else {
            // Checkbox
            const isChecked = this.checkboxTarget.checked;
            this.fieldsTarget.classList.toggle("d-none", !isChecked);
            if (!isChecked)
                this.clearFields(this.fieldsTarget);
        }
    }
    checkboxChanged(event) {
        const input = event.target;
        const toggleId = input.dataset.toggleTarget;
        const panel = document.getElementById(toggleId || "");
        if (!panel) {
            this.toggle();
        }
        else {
            this.toggle(panel, input.checked);
        }
    }
    clearFields(container) {
        const inputs = container.querySelectorAll("input, select, textarea");
        inputs.forEach((el) => {
            if (el.type === "checkbox" || el.type === "radio") {
                el.checked = false;
            }
            else {
                el.value = "";
            }
        });
    }
}
default_1.targets = ["checkbox", "fields", "radio", "panels"];
export default default_1;
